import React from 'react';

import type { Role, UserDto } from '../../../api/types';
import { getRoleToggleForAdminPage } from '../../../domain/admin/roleManagement';
import { roleLabel } from '../../../domain/auth/role';
import { getUserDisplayName, getInitialsFromName } from '../../../domain/users/display';
import { RoleBadge } from '../../../features/members/RoleBadge';
import { openTelegramProfileLink } from '../../../telegram/telegram';

import './UserCard.css';

export type UserCardProps = {
  user: UserDto;
  isAdmin: boolean;
  isSaving: boolean;
  onRoleChange: (user: UserDto, nextRole: Role) => void;
};

function getShortActionLabel(actionLabel: string): string {
  if (actionLabel === 'Назначить организатора') return '→ Орг';
  if (actionLabel === 'Снять организатора') return '→ Юзер';
  return '→ Орг';
}

export function UserCard({ user, isAdmin, isSaving, onRoleChange }: UserCardProps) {
  const name = getUserDisplayName(user);
  const initials = getInitialsFromName(name);
  const toggle = getRoleToggleForAdminPage(user.role);
  const canChange = isAdmin && !!toggle?.canChange && !isSaving;

  const handleCardClick = () => {
    openTelegramProfileLink({ telegramId: user.telegramId, username: user.username });
  };

  return (
    <div className="user-card-item">
      <button type="button" className="user-card-clickable" onClick={handleCardClick}>
        <div className="mi-avatar-wrap">
          <div className="mi-avatar">
            {user.photoUrl ? (
              <img src={user.photoUrl} alt={name} />
            ) : (
              <span className="member-avatar-placeholder">{initials}</span>
            )}
          </div>
        </div>
        <RoleBadge role={user.role} hasClubKey={user.hasClubKey} />
      </button>

      <div className="mi-content">
        <button
          type="button"
          className="user-card-clickable user-card-clickable--name"
          onClick={handleCardClick}
        >
          <div className="user-card-info">
            <span className="member-name">{name}</span>
            <span className="user-card-role-text">{roleLabel(user.role)}</span>
          </div>
        </button>

        {isAdmin && toggle && (
          <button
            type="button"
            className="user-card-action-btn"
            disabled={!canChange}
            title={toggle.actionLabel}
            onClick={() => {
              if (toggle.canChange) {
                onRoleChange(user, toggle.nextRole);
              }
            }}
          >
            {isSaving ? '…' : getShortActionLabel(toggle.actionLabel)}
          </button>
        )}
      </div>
    </div>
  );
}
